/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var formatter = MoyaContainer.get('core.formatter');
    MoyaComponents.register('ecar.filter.slider', [
        'https://unpkg.com/nouislider@14.6.1/distribute/nouislider.min.js',
        'https://unpkg.com/nouislider@14.6.1/distribute/nouislider.min.css',
    ], function (el) {
        var sliderElement = el.querySelector('.slider');
        if (!sliderElement) {
            return;
        }
        var selectedPriceInput = el.querySelector('input');
        var min = parseInt(selectedPriceInput.dataset.min);
        var max = parseInt(selectedPriceInput.dataset.max);
        var start = selectedPriceInput.dataset.start ? parseInt(selectedPriceInput.dataset.start) : min;
        var end = selectedPriceInput.dataset.end ? parseInt(selectedPriceInput.dataset.end) : max;
        var step = parseInt(selectedPriceInput.dataset.step);
        var symbol = selectedPriceInput.dataset.symbol;
        var minLabel = el.querySelector('.min');
        var maxLabel = el.querySelector('.max');
        var config = {
            slider: sliderElement,
            selectedPriceInput: selectedPriceInput,
            min: min,
            max: max,
            start: start,
            end: end,
            step: step,
            minLabel: minLabel,
            maxLabel: maxLabel,
            symbol: symbol,
        };
        var sliderFilter = new SliderFilter(config);
        sliderFilter.init();
        MoyaContainer.set('ecar.filter.slider', sliderFilter);
        MoyaEventHandler.dispatch('ecar.sliderFilterInit', {
            sliderFilter: sliderFilter,
        });
    });
    var SliderFilter = /** @class */ (function () {
        function SliderFilter(config) {
            this.slider = config.slider;
            this.selectedPriceInput = config.selectedPriceInput;
            this.min = config.min;
            this.max = config.max;
            this.start = config.start;
            this.end = config.end;
            this.step = config.step;
            this.minLabel = config.minLabel;
            this.maxLabel = config.maxLabel;
            this.symbol = config.symbol;
        }
        SliderFilter.prototype.init = function () {
            var options = {
                start: [this.start, this.end],
                connect: true,
                range: {
                    'min': this.min,
                    'max': this.max,
                },
                step: this.step,
            };
            if (this.step === -1) {
                return;
            }
            noUiSlider.create(this.slider, options);
            this.run();
        };
        SliderFilter.prototype.run = function () {
            var _this = this;
            this.slider.noUiSlider.on('slide', function () {
                _this.slide();
            });
            this.slider.noUiSlider.on('change', function () {
                var form = _this.slider.closest('form');
                form.submit();
            });
            this.slide();
        };
        SliderFilter.prototype.slide = function () {
            var _a, _b;
            var values = this.slider.noUiSlider.get();
            var currMin = parseInt(values[0]);
            var currMax = parseInt(values[1]);
            if (currMin === this.min && currMax === this.max) {
                this.selectedPriceInput.value = '';
            }
            else {
                this.selectedPriceInput.value = currMin + "-" + currMax;
            }
            var minPrice = formatter.formatMoney(currMin, (_a = this.symbol, (_a !== null && _a !== void 0 ? _a : '')));
            var maxPrice = formatter.formatMoney(currMax, (_b = this.symbol, (_b !== null && _b !== void 0 ? _b : '')));
            this.minLabel.innerHTML = minPrice;
            this.maxLabel.innerHTML = maxPrice;
        };
        return SliderFilter;
    }());

    exports.SliderFilter = SliderFilter;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
